
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ReviewQuality extends Vue {
  @Prop() label!: string;
  @Prop() mark!: 'pro' | 'con';
}
